export default __webpack_public_path__ + "static/media/33g.2219752c.svg";